import ShareMsgBase from './A_G.ShareMsgBase';

class MsgCoins extends ShareMsgBase {
  /**
   * The message that is sent when you click on the coins on the leaderboard to the friend
   * @param {string} user1AvatarURL
   * @param {function} onAllImagesReadyCallback
   */
  constructor(user1AvatarURL, onAllImagesReadyCallback = null) {
    super(2, onAllImagesReadyCallback);

    this.avatar1 = this._addExtImage(279, 107, user1AvatarURL, 0, 132, null);
    this.bg = this._addExtImage(0, 0, 'img/Msg_Coins.png', 0, null, null);
  }
}

// create global references
G.MsgCoins = MsgCoins;
